import { useAuth as r } from "react-oauth2-pkce";
import { j as i } from "./jwt-to-user.helper-2e5f8f3e.js";
import "jwt-decode";
function c() {
  var o;
  const { authService: t } = r(), e = i((o = t.getAuthTokens()) == null ? void 0 : o.access_token);
  return {
    user: e,
    login: () => t.authorize(),
    logout: () => t.logout(),
    isPending: () => t.isPending(),
    isAuthenticated: () => {
      if (t.isAuthenticated()) {
        if (e && !e.expired())
          return !0;
        t.logout();
      }
      return !1;
    }
  };
}
export {
  c as useJwtUser
};
